var _rect, _path, _mask, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeAdmissionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 1,
    width: 20,
    height: 30,
    rx: 1,
    stroke: "#46C35F",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.19343C14 5.80141 14.2291 5.44555 14.5859 5.28321L22.5859 1.6434C23.248 1.34214 24 1.82617 24 2.55361V29.4962C24 30.2108 23.2722 30.6947 22.6132 30.4183L14.6132 27.0629C14.2417 26.9071 14 26.5436 14 26.1407V6.19343Z",
    fill: "#46C35F"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_208_3658",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8.80371,
    width: 15,
    height: 15,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: 8.80371,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 21.196L13 15.9999L6.25 10.8037V14.9999H1V16.9999H6.25V21.196Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 21.196L13 15.9999L6.25 10.8037V14.9999H1V16.9999H6.25V21.196Z",
    fill: "#46C35F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.9999L13.488 16.6338L14.3115 15.9999L13.488 15.3659L13 15.9999ZM6.25 21.196H5.45V22.8214L6.738 21.8299L6.25 21.196ZM6.25 10.8037L6.738 10.1698L5.45 9.17829V10.8037H6.25ZM6.25 14.9999V15.7999H7.05V14.9999H6.25ZM1 14.9999V14.1999H0.2V14.9999H1ZM1 16.9999H0.2V17.7999H1V16.9999ZM6.25 16.9999H7.05V16.1999H6.25V16.9999ZM12.512 15.3659L5.762 20.5621L6.738 21.8299L13.488 16.6338L12.512 15.3659ZM5.762 11.4376L12.512 16.6338L13.488 15.3659L6.738 10.1698L5.762 11.4376ZM7.05 14.9999V10.8037H5.45V14.9999H7.05ZM1 15.7999H6.25V14.1999H1V15.7999ZM1.8 16.9999V14.9999H0.2V16.9999H1.8ZM6.25 16.1999H1V17.7999H6.25V16.1999ZM7.05 21.196V16.9999H5.45V21.196H7.05Z",
    fill: "white",
    mask: "url(#path-3-outside-1_208_3658)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 15,
    width: 5,
    height: 2,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAdmissionIcon);
export default __webpack_public_path__ + "static/media/home_admission_icon.982936b8606634801d46acb95c946164.svg";
export { ForwardRef as ReactComponent };